import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import PageFooter from "../../components/Footer/PageFooter";

const Layout = () => {
  const location = useLocation();

  return (
    <>
      <Navbar />

      <Outlet />
      {/* <PageFooter /> */}
      {location.pathname !== "/" ? <PageFooter /> : <Footer />}
    </>
  );
};

export default Layout;
